import { Controller } from "@hotwired/stimulus"
import $ from 'jquery';
import select2 from 'select2'
select2();

export default class extends Controller {
  connect() {
    console.log("SELECT2 controller ok");

    const $selects = $(this.element).find('.select2');

    console.log("select2:", typeof $.fn.select2);

    $selects.each(function() {
      const $select = $(this);

      $select.select2({
        theme: "bootstrap-5",
        width: $select.data('width') || ($select.hasClass('w-100') ? '100%' : 'style'),
        placeholder: $select.data('placeholder'),
      });

      // Trigger change event when Select2 value changes (use select2:select to avoid infinite loop)
      $select.on('select2:select select2:unselect', function() {
        console.log("Select2 value changed");
        // Dispatch native change event for Stimulus controllers (only once)
        const event = new Event('change', { bubbles: true });
        // Use setTimeout to prevent recursion
        setTimeout(() => {
          this.dispatchEvent(event);
        }, 0);
      });
    });
  }

  disconnect() {
    const $selects = $(this.element).find('.select2');
    $selects.select2('destroy');
  }
}
